import React, { Component } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from "react-loader-spinner";
import $ from "jquery";

export default class GenerativeAI extends Component {
  constructor() {
    super();

    this.state = {
      generativeAiRecord: this.getEmptyRecord(),
      showLoader: false,
      context: "",
      showEditMode: false,
      preventRedundantUse: false,
      llmArray: [],
      llmData: {},
    };

    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }

  componentDidMount() {
    this.fetchGenerativeRecordByProjectId();
    this.fetchLLMsApi();
    var thisComponent = this;
    document.addEventListener("projectChanged", function (event) {
      thisComponent.projectId = event.projectId;
      thisComponent.state.showEditMode = false;
      thisComponent.state.generativeAiRecord = thisComponent.getEmptyRecord();
      thisComponent.fetchGenerativeRecordByProjectId(event.projectId);
      thisComponent.fetchLLMsApi();
    });
  }

  getEmptyRecord = () => {
    return {
      id: "",
      projectId: localStorage.getItem("currentProjectId"),
      apiKey: "",
      llm: "Azure -  GPT3.5 Turbo",
      language: "ENGLISH",
      context: "",
      preventRedundantUse: false,
    };
  };

  fetchLLMsApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisComponent = this;
    thisComponent.state.showLoader = true;
    $.ajax({
      url: "/api/llm-values",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisComponent.state.showLoader = false;
        if (res.success === true) {
          const dataObject = res.result; // This holds the key-value pairs
          const dataKeys = Object.keys(dataObject);
          const llm = thisComponent.state.generativeAiRecord.llm;

          // Initialize llmArray and llm for state
          const llmArray = [];
          const llmValueToKeyMap = {};

          // Fill llmArray and llmValueToKeyMap
          for (const [key, value] of Object.entries(dataObject)) {
            llmArray.push(key);
            llmValueToKeyMap[value] = key;
          }

          // If llm value is present, prepend it to llmArray
          if (llm) {
            const llmKey = llmValueToKeyMap[llm];
            const llmIndex = llmArray.indexOf(llmKey);
            if (llmIndex !== -1) {
              llmArray.splice(llmIndex, 1);
            }
            llmArray.unshift(llmKey);
          }

          thisComponent.state.llm = llm ? llmValueToKeyMap[llm] : dataKeys[0];
          thisComponent.state.llmData = dataObject;
          const filteredArray = llmArray.filter((item) => {
            return typeof item === "string" && item.trim() !== "";
          });
          thisComponent.state.llmArray = filteredArray;
          thisComponent.setState(thisComponent.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }

  getKeyFromValue = (dataObject, value) => {
    for (const [key, val] of Object.entries(dataObject)) {
      if (val === value) {
        return key;
      }
    }
    return null; // return null if the value is not found
  };

  fetchGenerativeRecordByProjectId(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisComponent = this;
    thisComponent.state.showLoader = true;
    $.ajax({
      url: "/api/generative-ai-projectId",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisComponent.state.showLoader = false;
        if (res.success == true) {
          var recordData = res.result[0];
          if (recordData) {
            thisComponent.state.context = recordData.context
              ? recordData.context
              : "";
            thisComponent.state.preventRedundantUse =
              recordData.preventRedundantUse
                ? recordData.preventRedundantUse
                : false;
            thisComponent.state.generativeAiRecord = recordData;
          }
          thisComponent.setState(thisComponent.state);
        } else {
          thisComponent.setState({
            generativeAiRecord: thisComponent.getEmptyRecord(),
          });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }

  handleContext = (e) => {
    this.state.generativeAiRecord.context = e.target.value;
    this.setState(this.state);
  };

  handleCheckboxChange = (e) => {
    this.state.preventRedundantUse = e.target.checked;
    this.setState(this.state);
  };

  handleLLMChange = (e) => {
    const selectedKey = e.target.value;
    const selectedValue = this.state.llmData[selectedKey];
    this.state.generativeAiRecord.llm = selectedKey;
    this.setState(this.state);
  };

  notifyInvalidFields = (errorMsg) => {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{errorMsg}
      </b>,
      {
        position: "top-center",
      }
    );
  };

  notifyError(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  validateFields = () => {
    if (this.state.generativeAiRecord.context.trim().length <= 0) {
      this.notifyInvalidFields("Context is empty or invalid");
      return false;
    } else if (
      !this.state.generativeAiRecord.llm ||
      this.state.generativeAiRecord.llm.trim().length <= 0
    ) {
      this.notifyInvalidFields("Pleas select an LLM");
      return false;
    }
    return true;
  };

  saveGenerativeRecordApi = (e) => {
    var saveRecordController = this;

    if (this.validateFields()) {
      var method = "POST";

      var saveData = saveRecordController.state.generativeAiRecord;
      saveData.projectId = localStorage.getItem("currentProjectId");
      saveData.preventRedundantUse =
        saveRecordController.state.preventRedundantUse;
      if (saveData.id) {
        method = "PATCH";
      }

      $.ajax({
        url: "/api/generative-ai",
        async: false,
        method: method,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(saveData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            saveRecordController.state.disabled = false;
            saveRecordController.state.showEditMode = false;
            saveRecordController.refreshData();
          } else {
            saveRecordController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        },
      });
    }
  };

  fetchAllApis = () => {
    this.fetchGenerativeRecordByProjectId();
    this.fetchLLMsApi();
  };

  refreshData = () => {
    this.setState({
      generativeAiRecord: this.getEmptyRecord(),
      showEditMode: false,
    });
    setTimeout(() => {
      this.fetchAllApis();
    }, 200);
  };

  render() {
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.showLoader}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />

        <div style={{ display: !this.state.showLoader ? "block" : "none" }}>
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <ToastContainer className="Toast-at-center" />

          <div className="content-header">
            <div className="container-fluid">
              <div
                className="row"
                style={{ alignItems: "center", justifyContent: "flex-start" }}
              >
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Global Prompt</h1>
                  <h6 className="taglineTxt">
                    Global prompt for your agent's GPT
                  </h6>
                </div>

                <div
                  className="d-flex flex-row-reverse pt-2 col-sm-2"
                  align="right"
                  style={{ marginLeft: "30rem" }}
                >
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                    style={{ marginLeft: "1rem" }}
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>

                  <button
                    className="btn action-button "
                    title={this.state.showEditMode ? "Save" : "Edit"}
                    id="addMsg"
                    style={{ marginRight: "-2px" }}
                    onClick={(e) => {
                      this.state.showEditMode
                        ? this.saveGenerativeRecordApi(e)
                        : this.setState({ showEditMode: true });
                    }}
                  >
                    <img
                      src={
                        this.state.showEditMode
                          ? this.saveImageSrc
                          : this.editImageSrc
                      }
                    />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <div
                            className="card-body raise-form"
                            style={{ minHeight: "450px" }}
                          >
                            <div
                              className="row"
                              style={{
                                display: "flex",

                                justifyContent: "flex-start",
                              }}
                            >
                              <div className="col-sm-8">
                                <h6
                                  className="nav-item"
                                  style={{
                                    color: "#282a65",
                                    marginTop: "10px",
                                  }}
                                >
                                  Provide the context
                                </h6>
                                <textarea
                                  value={this.state.generativeAiRecord.context}
                                  name=""
                                  rows="12"
                                  cols="100"
                                  onChange={this.handleContext}
                                  disabled={
                                    this.state.showEditMode ? false : true
                                  }
                                ></textarea>
                              </div>

                              <div
                                className="col-sm-8"
                                style={{
                                  marginTop: "25px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  maxWidth: "59%",
                                }}
                              >
                                {" "}
                                <div
                                  style={{
                                    display: "flex",

                                    justifyContent: "center",
                                    gap: "20px",
                                  }}
                                >
                                  <span>
                                    <label>Prevent Redundent Use : </label>
                                  </span>
                                  <label class="switch">
                                    <input
                                      type="checkbox"
                                      id={"activate"}
                                      onChange={(e) =>
                                        this.handleCheckboxChange(e)
                                      }
                                      checked={this.state.preventRedundantUse}
                                      disabled={
                                        this.state.showEditMode ? false : true
                                      }
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    width: "50%",
                                  }}
                                >
                                  <label>LLM's</label>
                                  <select
                                    className="input-group mb-3 form-control select2"
                                    id="docLanguage"
                                    disabled={!this.state.showEditMode}
                                    value={this.state.generativeAiRecord.llm}
                                    onChange={this.handleLLMChange}
                                    style={{
                                      width: "100%",
                                      height: "30px",
                                      borderRadius: "4px",
                                      backgroundColor: "#F9F9FB",
                                    }}
                                  >
                                    {this.state.llmArray.map((key) => (
                                      <option
                                        key={key}
                                        value={this.state.llmData[key]}
                                      >
                                        {key}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/projectmgmt/faq/GenerativeAI.js